import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { contactAgentApi } from '../api/contactAgentApi';
import { contactAgentError } from '../api/contactAgentScope';
import type { CampaignRepliesPage } from '@workspace/types';

export function CampaignRepliesPanel({
  campaignId,
  onError,
}: {
  campaignId: string;
  onError: (message: string) => void;
}) {
  const [page, setPage] = useState<CampaignRepliesPage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    void contactAgentApi
      .getCampaignReplies(campaignId, { limit: 8 })
      .then(result => {
        if (!cancelled) {
          setPage(result);
        }
      })
      .catch(err => {
        if (!cancelled) {
          onError(contactAgentError(err));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [campaignId, onError]);

  return (
    <Card className='rounded-xl'>
      <CardHeader className='pb-2'>
        <CardTitle className='text-lg'>Respuestas</CardTitle>
        <p className='text-sm text-muted-foreground'>
          Mensajes que contestaron a esta notificación. Si hay respuesta automática, se envía una sola vez.
          BAJA se atiende aparte.
        </p>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className='text-sm text-muted-foreground'>Cargando respuestas...</p>
        ) : !page || page.total === 0 ? (
          <p className='text-sm text-muted-foreground'>Todavía no hay respuestas.</p>
        ) : (
          <div className='overflow-auto rounded-xl border'>
            <table className='w-full text-sm'>
              <thead className='sticky top-0 bg-background'>
                <tr className='border-b text-left'>
                  <th className='px-3 py-2'>Fecha</th>
                  <th className='px-3 py-2'>Contacto</th>
                  <th className='px-3 py-2'>Texto</th>
                </tr>
              </thead>
              <tbody>
                {page.items.map(item => (
                  <tr key={item.id} className='border-b last:border-0 hover:bg-muted/40'>
                    <td className='px-3 py-2 whitespace-nowrap text-muted-foreground'>
                      {new Date(item.receivedAt).toLocaleString('es-AR')}
                    </td>
                    <td className='px-3 py-2'>{item.contactMasked}</td>
                    <td className='px-3 py-2'>{item.body || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
